import React from "react";
import { SvgIcon } from "../../../src/index";
var compPaths = {
  s: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M5.813 12v4.5c0 .932.756 1.687 1.687 1.687h9c.931 0 1.688-.755 1.688-1.687V12M12 15.934v-9.55m3.58 3.241L12 6.045l-3.58 3.58"
  })),
  m: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "1.5",
    d: "M3.75 13v6A2.25 2.25 0 006 21.25h12A2.25 2.25 0 0020.25 19v-6M12 19V4m4.773 4.834l-4.772-4.773-4.774 4.773"
  })),
  l: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: "3",
    d: "M7.5 26v12a4.5 4.5 0 004.5 4.5h24a4.5 4.5 0 004.5-4.5V26M24 38V8m9.547 9.668l-9.546-9.546-9.548 9.546"
  }))
};
export var Share = /*#__PURE__*/React.memo(function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, Object.assign({}, props, {
    paths: compPaths,
    fill: "none"
  }));
});